import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface AfterSalesBuyingHistoryFilters {
  productName: string
  customerName: string
  nickname: string
  unionid: string
  channelName: string
  isSigned: string
  channelCode: string
  status: string
  isRefund: string
  payTime?: string[]
}

export interface AfterSalesBuyingHistoryRecord {
  id?: string | number
  customerName: string
  nickname: string
  unionid: string
  channelName: string
  productName: string
  price: number
  signUrl: string
  isSigned: string
  deptName: string
  empName: string
  payTime: string
  orderId: string
  status: string | number
  channelCode: string
  isRefund: string
  refundAmount: number
}

function buildParams(query: PageQuery<AfterSalesBuyingHistoryFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize
  }
}

export async function fetchAfterSalesBuyingHistoryPage(
  query: PageQuery<AfterSalesBuyingHistoryFilters>,
  signal: AbortSignal
): Promise<PageResult<AfterSalesBuyingHistoryRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/afterSalesLiveQuanzi/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<AfterSalesBuyingHistoryRecord>(payload)
}
